import React, { useEffect } from 'react';

import { useToggles } from '../../../../state/toggles';
import { useAppDispatchers } from '../../../../state/app';
import {
  BaseFundingAccountProps,
  BillingAddressProps,
  WIDGET_NAME
} from '../shared';

import Debit from '.';

export default function DebitContainer({
  fundingSource,
  setFundingSource,
  getInitialFundingAmount,
  submitPaymentMethod
}: BaseFundingAccountProps) {
  const { answer, createError, clearError, getBraintreeToken } =
    useAppDispatchers();
  const { enhancedDebit } = useToggles();

  useEffect(() => {
    getBraintreeToken();
  }, []);

  const createErrorDispatch = (msg: string) => {
    createError({ message: msg, registrationStep: WIDGET_NAME });
  };

  const clearErrorDispatch = () => {
    clearError();
  };

  const handlePayment = (
    nonce: string,
    type: string,
    billingAddress?: BillingAddressProps,
    details?: { [key: string]: any }
  ) => {
    submitPaymentMethod(
      {
        nonce,
        provider: 'braintree',
        source: 'debit',
        type,
        loadAmount: getInitialFundingAmount(),
        ...(billingAddress ? { billingAddress } : {}),
        details
      },
      answer
    );
  };

  return (
    <Debit
      fundingSource={fundingSource}
      setFundingSource={setFundingSource}
      loadAmount={getInitialFundingAmount()}
      enhancedDebitOptions={
        enhancedDebit || {
          applePayEnabled: false,
          googlePayEnabled: false,
          threeDSEnabled: false,
          venmoEnabled: false,
          paypalEnabled: false
        }
      }
      handlePayment={handlePayment}
      createErrorDispatch={createErrorDispatch}
      clearErrorDispatch={clearErrorDispatch}
    />
  );
}
